import React from "react";

import _ from "underscore";

import PropTypes from 'prop-types';

import MultiSelectFilter from './MultiSelectFilter';
import AddItemFromList from './AddItemFromList';
import Immutable from 'immutable';

let MAX_FILTER_COUNT = 150;

class MultiSelectFilterContainer extends React.Component {
  constructor(...args) {
    super(...args);

    this.addFilter = this.addFilter.bind(this);
    this.removeFilter = this.removeFilter.bind(this);
    this._applyFilter = this._applyFilter.bind(this);
    this._canFilter = this._canFilter.bind(this);

    var filters = Immutable.OrderedMap();
    _.each(this.props.filters, function(value, key) {
      if (this.props.paramFilters && this.props.paramFilters[key]) {
        filters = filters.set(key, this.props.paramFilters[key]);
      }
    }, this);

    this.state = {
      filters: filters
    };
  }

  addFilter(filter) {
    this.setState({
      filters: this.state.filters.set(filter.key, []),
      openFilter: filter.key
    });
  }

  removeFilter(filterName) {
    this.updateFilters(this.state.filters.delete(filterName));
  }

  _applyFilter(filters, name) {
    this.updateFilters(this.state.filters.set(name, _.pluck(filters, 'id')));
  }

  updateFilters(filters) {
    this.setState({
      filters: filters
    });
    this.props.callback(filters.toJS());
  }

  destroyFilters() {
    if (this.state.filters.size > 0) {
      var filters = Immutable.OrderedMap();
      this.updateFilters(filters);
    }
  }

  render() {
    var multiSelectFilters = this.state.filters.map(function(paramFilters, filterName) {
      var urlConfig = this.props.filters[filterName];
      return (
        <MultiSelectFilter
          name={filterName}
          title={this.props.titlePrefix + urlConfig.friendlyName}
          hideLabel={this.props.hideLabels}
          allSelectedText={urlConfig.allSelectedText}
          fixedWidth={this.props.fixedWidth}
          url={urlConfig.url}
          values={urlConfig.values}
          onApply={this._applyFilter}
          initialItems={paramFilters}
          key={filterName}
          canFilter={this._canFilter}
          maxItems={MAX_FILTER_COUNT}
          open={this._isFilterOpen(filterName)}
          onRemoveFilter={this.removeFilter}
        />
      );
    }, this);

    var addFilterDropDown =
      <AddItemFromList
        availableItems={ this._getNonActiveFilters() }
        itemCallback={ this.addFilter }
        label={ this._getAddFilterLabel() }
        shouldSort={this.props.shouldSort}
        disabled={ !this.props.enabled }
        disabledButtonLabel={ "You have selected all of your filters" }
      />;

    return (
      <div data-id="multi-select-filter-container" className="multiselect-dropdown-container-group">
        {multiSelectFilters.valueSeq()}
        {addFilterDropDown}
      </div>
    );
  }

  _getAddFilterLabel() {
    if (this.state.filters.isEmpty() && !this.props.hideLabels) {
      return "Add Filter";
    } else {
      return "";
    }
  }

  _getNonActiveFilters() {
    var nonActiveFilters = Immutable.OrderedMap(this.props.filters).filterNot(function(config, filterName) {
      return this.state.filters.has(filterName);
    }, this).toObject();

    var availableFilters = Object.keys(nonActiveFilters).map(function(key) {
      var filterConfig = nonActiveFilters[key];
      filterConfig["key"] = key;
      return filterConfig;
    });

    return availableFilters;
  }

  _isFilterOpen(filterName) {
    return filterName === this.state.openFilter;
  }

  _canFilter(filters, filterName) {
    var count = 0;
    this.state.filters.forEach(function(filter, key) {
      if (key !== filterName) {
        count += filter.length;
      }
    });
    return (count + filters.length) <= MAX_FILTER_COUNT;
  }
}

MultiSelectFilterContainer.propTypes = {
  callback:       PropTypes.func.isRequired,
  filters:        PropTypes.object,
  paramFilters:   PropTypes.object,
  titlePrefix:    PropTypes.string,
  hideLabels:     PropTypes.bool,
  enabled:        PropTypes.bool,
  fixedWidth:     PropTypes.bool,
  shouldSort:     PropTypes.bool
};

export default MultiSelectFilterContainer;
